import { defineMessages } from "react-intl";
export const messages = defineMessages({
    spacesCommunitySearch: {
        id: "spaces.layout.search.community",
        defaultMessage: "Search for a community",
    },
    spacesAddressSearch: {
        id: "spaces.layout.search.address",
        defaultMessage: "Search for an address",
    },
});
